import { Component, input, output, effect, DestroyRef, inject } from '@angular/core'

@Component({
  selector: 'app-saving-indicator',
  standalone: true,
  imports: [],
  templateUrl: './saving-indicator.component.html'
})
export class SavingIndicatorComponent {
  state = input<'saving' | 'saved'>('saving')
  savedDone = output<void>()

  private _savedTimeout: ReturnType<typeof setTimeout> | null = null
  private readonly _destroyRef = inject(DestroyRef)

  constructor() {
    this._destroyRef.onDestroy(() => {
      if (this._savedTimeout !== null) {
        clearTimeout(this._savedTimeout)
        this._savedTimeout = null
      }
    })
    effect(() => {
      const s = this.state()
      if (s === 'saved') {
        if (this._savedTimeout !== null) clearTimeout(this._savedTimeout)
        this._savedTimeout = setTimeout(() => {
          this._savedTimeout = null
          this.savedDone.emit()
        }, 2000)
      }
    })
  }
}
